import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[normalizeDecimalSeparator]',
})
export class NormalizeDecimalSeparatorDirective {
    /** ',' oppure '.' */
    readonly separatorInUse = input<',' | '.'>(',', { alias: 'normalizeDecimalSeparator' });

    private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);
    private readonly ngControl = inject(NgControl);

    @HostListener('paste')
    @HostListener('input')
    onInputLike() {
        queueMicrotask(() => {
            const inputEl = this.el.nativeElement;
            const raw = inputEl.value ?? '';

            const sep = this.separatorInUse();
            if (sep === '.') return; // niente da fare

            // sostituisci TUTTI i punti con il separatore corrente
            const normalized = raw.replace(/\./g, sep);

            if (normalized !== raw) {
                inputEl.value = normalized;

                // sync col FormControl se esiste
                this.ngControl.control?.setValue(normalized, { emitEvent: false });
                this.ngControl.control?.markAsDirty();
            }
        });
    }
}
